module.exports = {"data":{"allWebCampaign":{"edges":[{"node":{"id":"5b99be8e27c22293710b0a7807de869e","webCampaignId":5,"orderNumber":100,"title":"Flick!On!TVとは","isPublished":true,"imageTitle":"Flick!On!TVとは","imageUrl":"https://s3-ap-northeast-1.amazonaws.com/flickontv-ios/img/WebCampaigns/5ad8d34e81a1e.jpg","url":"/about"}}]}},"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/index.json
// module id = 651
// module chunks = 142629428675168